"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var firestore_1 = require("firebase/firestore");
var omit_1 = __importDefault(require("lodash/omit"));
var querystring_1 = require("querystring");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var SelectButtonGrid_1 = __importDefault(require("atomicComponents/organisms/Button/SelectButtonGrid"));
var useUploadTransactions_1 = require("containers/Admin/CustomerManagement/CompanyActions/useUploadTransactions");
var ConnectionSuccess_1 = __importDefault(require("containers/Settings/Integrations/NewConnection/ConnectionSuccess"));
var utils_1 = require("containers/Settings/Integrations/NewConnection/utils");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var BackdropLoader_1 = __importDefault(require("shared/components/Loaders/BackdropLoader"));
var Text_1 = __importDefault(require("shared/components/Text"));
var analytics_1 = require("utils/analytics");
var backend_1 = require("utils/backend");
var firebaseConf_1 = require("utils/firebaseConf");
var general_1 = require("utils/general");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var hooks_2 = require("../Wizard/hooks");
var ConnectionError_1 = __importDefault(require("./ConnectionAlerts/ConnectionError"));
var SupportedOptionTemplate_1 = __importDefault(require("./ConnectionAlerts/OptionTemplates/SupportedOptionTemplate"));
var UnsupportedOptionTemplate_1 = __importDefault(require("./ConnectionAlerts/OptionTemplates/UnsupportedOptionTemplate"));
var constants_1 = require("./constants");
var WizardParts_1 = require("./WizardParts");
var ConnectAccSoftware = function () {
    var _a = __read((0, hooks_1.useSearch)('connected'), 2), successMessage = _a[0], setSuccessMessage = _a[1];
    var _b = __read((0, hooks_1.useSearch)('error'), 2), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = __read((0, react_1.useState)(null), 2), transactionsData = _c[0], setTransactionsData = _c[1];
    var _d = (0, react_router_dom_1.useLocation)(), pathname = _d.pathname, search = _d.search;
    var formValues = (0, react_final_form_1.useFormState)({ subscription: { values: true } }).values;
    var mainAccountingConnection = (0, react_redux_1.useSelector)(single_1.selectMainAccountingConnection);
    var provider = formValues.mainAccountingConnection.provider;
    var _e = __read((0, react_1.useState)(provider), 2), selectedProvider = _e[0], setSelectedProvider = _e[1];
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var _f = __read((0, backend_1.useCall)('transactions-getAccConnection', {
        companyId: company.id,
        purpose: company.isAccountingFirm ? 'RECHRGLY' : undefined,
    }), 2), getAccConnection = _f[0], isSending = _f[1];
    var _g = __read((0, useUploadTransactions_1.useUploadTransactions)(company.id), 2), uploadTransactions = _g[0], isUploadingCsv = _g[1];
    var onNextClick = react_1.default.useContext(WizardParts_1.WizardContext).onNextClick;
    var _h = __read((0, hooks_1.useSubmitter)('companies', company.id), 1), updateCompany = _h[0];
    var isSupportedPlatform = (0, interfaces_1.isSupportedAccPlatform)(selectedProvider);
    var trackStep = (0, hooks_2.useTrackStep)(WizardParts_1.WizardContext);
    var trackSelect = (0, analytics_1.usePreparedTracker)('Accounting Provider Selected', { context: 'Onboarding' });
    var activationTracker = (0, analytics_1.usePreparedTracker)('Activation Step Completed');
    var history = (0, react_router_1.useHistory)();
    var redirectPath = "".concat(pathname, "?wzStep=SET_ACCOUNTING&provider=").concat(provider, "&fromOauth=true");
    var reconnectPath = "".concat(pathname, "?wzStep=SET_ACCOUNTING");
    react_1.default.useEffect(function () {
        var qParams = (0, querystring_1.parse)(search.replace(/^\?/, ''));
        if (qParams.fromOauth === 'true' && !qParams.oauthError && !qParams.error) {
            activationTracker({
                accountingSystem: qParams.provider,
                resolution: 'Supported Accounting',
                stepNumber: 2.5,
            });
            history.push("".concat(window.location.pathname, "?").concat((0, querystring_1.stringify)((0, omit_1.default)(qParams, ['fromOauth', 'wzStep']))));
            onNextClick();
        }
    });
    var setAccSoftIfNeed = function () { return __awaiter(void 0, void 0, void 0, function () {
        var mainAccountingConnectionRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((mainAccountingConnection === null || mainAccountingConnection === void 0 ? void 0 : mainAccountingConnection.provider) === provider)
                        return [2 /*return*/, null];
                    mainAccountingConnectionRef = (mainAccountingConnection === null || mainAccountingConnection === void 0 ? void 0 : mainAccountingConnection.isDraft) || !company.mainAccConnectionId
                        ? firebaseConf_1.db.collection('integration_connections').doc(company.mainAccConnectionId)
                        : firebaseConf_1.db.collection('integration_connections').doc();
                    return [4 /*yield*/, mainAccountingConnectionRef.set({ companyId: company.id, provider: provider, isDraft: true }, { merge: true })];
                case 1:
                    _a.sent();
                    if (!!company.mainAccConnectionId) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateCompany({ mainAccConnectionId: mainAccountingConnectionRef.id })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, {}];
            }
        });
    }); };
    var onBeforeNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setAccSoftIfNeed()];
                case 1:
                    _a.sent();
                    if (!(transactionsData && !isSupportedPlatform)) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateCompany({ hasUploadedCsv: true })];
                case 2:
                    _a.sent();
                    uploadTransactions(transactionsData);
                    setTransactionsData(null);
                    _a.label = 3;
                case 3:
                    trackStep({ stepName: 'CONNECT_ACCOUNTING', resolution: 'CSV Uploaded', stepNumber: 2.5 });
                    return [2 /*return*/];
            }
        });
    }); };
    var connect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!selectedProvider)
                        return [2 /*return*/];
                    return [4 /*yield*/, (0, utils_1.connectAccountingSystem)(getAccConnection, redirectPath, selectedProvider)];
                case 1:
                    _b.sent();
                    if (!(!company.hasRefreshToken && ((_a = company.completedWelcomeOnbSteps) === null || _a === void 0 ? void 0 : _a.includes('SET_ACCOUNTING')))) return [3 /*break*/, 3];
                    // If company has step SET_ACCOUNTING but doesn't hasRefreshToken, it probably completed this step with
                    // a non-supported acc platform (maybe playing around)
                    return [4 /*yield*/, updateCompany({ completedWelcomeOnbSteps: (0, firestore_1.arrayRemove)('SET_ACCOUNTING') })];
                case 2:
                    // If company has step SET_ACCOUNTING but doesn't hasRefreshToken, it probably completed this step with
                    // a non-supported acc platform (maybe playing around)
                    _b.sent();
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var isInitialStep = (isSupportedPlatform && !company.hasRefreshToken) || !selectedProvider;
    var isNextDisabled = !isUploadingCsv && (!selectedProvider
        || (!isSupportedPlatform && !transactionsData)
        || (isSupportedPlatform && (mainAccountingConnection === null || mainAccountingConnection === void 0 ? void 0 : mainAccountingConnection.provider) !== selectedProvider));
    if (isUploadingCsv) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "We are processing your transactions" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, mt: 6 }, { children: "If you would like to upload a new CSV you will have the opportunity to do so once you arrive at the dashboard." }))] }));
    }
    return ((0, jsx_runtime_1.jsxs)(WizardParts_1.StepTemplate, __assign({ onBeforeNext: onBeforeNext, isNextDisabled: isNextDisabled, onSkipClick: !isUploadingCsv && (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!provider) return [3 /*break*/, 2];
                        return [4 /*yield*/, setAccSoftIfNeed()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        trackStep({ resolution: 'Skipped' });
                        return [4 /*yield*/, onNextClick()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }) }, { children: [isSending && ((0, jsx_runtime_1.jsx)(BackdropLoader_1.default, { msg: "We're syncing to ".concat((0, end2end_1.getProviderAsNice)(provider), ". It'll be a few seconds. Sit tight.") })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%", width: "100%" }, { children: [(isInitialStep || isSupportedPlatform) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Connect an accounting system" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, pt: 2, pb: 4 }, { children: "Hudled works best by scanning your transactions automatically to detect software spend." })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, pb: 2 }, { children: ["Which ", (0, jsx_runtime_1.jsx)("strong", { children: "accounting system" }), ' ', profile.isAccountant && !company.isAccountingFirm ? ' does your client' : ' do you', " use?"] }))] })), !!successMessage && (0, jsx_runtime_1.jsx)(ConnectionSuccess_1.default, { open: true, onClose: function () { return setSuccessMessage(''); } }), !!errorMessage && ((0, jsx_runtime_1.jsx)(ConnectionError_1.default, { errorMessage: errorMessage, open: true, onClose: function () { return setErrorMessage(''); }, buttonAction: function () { history.push(reconnectPath); setErrorMessage(''); } })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ pb: 2 }, { children: [!selectedProvider && ((0, jsx_runtime_1.jsx)(SelectButtonGrid_1.default, { options: (0, general_1.makeValueLabelArray)(interfaces_1.ACC_PLATFORMS, end2end_1.ACCOUNTING_PLATFORMS_MAPPER).map(function (option) {
                                    var _a, _b;
                                    return (__assign(__assign({}, option), { logo: (_a = constants_1.ACC_PLATFORMS_LOGO[option.value]) === null || _a === void 0 ? void 0 : _a.logo, icon: (_b = constants_1.ACC_PLATFORMS_LOGO[option.value]) === null || _b === void 0 ? void 0 : _b.icon }));
                                }), isSending: isSending, handleClick: function (newProvider) {
                                    setSelectedProvider(newProvider);
                                    trackSelect({ isSupported: isSupportedPlatform, provider: newProvider });
                                    trackStep({ accountingSystem: newProvider, resolution: isSupportedPlatform ? 'Supported Accounting' : 'CSV Upload' });
                                }, selectedValue: selectedProvider })), selectedProvider && isSupportedPlatform && ((0, jsx_runtime_1.jsx)(SupportedOptionTemplate_1.default, { provider: selectedProvider, isSending: isSending, onClick: connect, handleGoBack: function () { return setSelectedProvider(undefined); } })), selectedProvider && !isSupportedPlatform && ((0, jsx_runtime_1.jsx)(UnsupportedOptionTemplate_1.default, { provider: selectedProvider, formValues: formValues, transactionsData: transactionsData, setTransactionsData: setTransactionsData, handleGoBack: function () { return setSelectedProvider(undefined); } }))] }))] }))] })));
};
exports.default = ConnectAccSoftware;
